/**
 * @generated SignedSource<<5cfd17896a0a877518fcea64726e87ab>>
 * @relayHash aaceb57db889606b21c3c3c643965743
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6117ca94007bfe7c67d3f7a8081ddd2b570cefdee16d7939a12dc66c4723dd7

import type { ConcreteRequest } from 'relay-runtime';
export type useSelectionCountContentMetadataQuery$variables = {
  contentIds: ReadonlyArray<string>;
};
export type useSelectionCountContentMetadataQuery$data = {
  readonly databaseContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly embedContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly folderContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly pageContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly whiteboardContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSelectionCountContentMetadataQuery = {
  response: useSelectionCountContentMetadataQuery$data;
  variables: useSelectionCountContentMetadataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentIds"
  }
],
v1 = {
  "kind": "Variable",
  "name": "ids",
  "variableName": "contentIds"
},
v2 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "visibleDescendantsCount"
      }
    ]
  }
],
v3 = [
  {
    "alias": "pageContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "page"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "whiteboardContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "databaseContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "database"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "embedContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "embed"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "folderContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "folder"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSelectionCountContentMetadataQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSelectionCountContentMetadataQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "aaceb57db889606b21c3c3c643965743",
    "id": "e6117ca94007bfe7c67d3f7a8081ddd2b570cefdee16d7939a12dc66c4723dd7",
    "metadata": {},
    "name": "useSelectionCountContentMetadataQuery",
    "operationKind": "query",
    "text": "query useSelectionCountContentMetadataQuery($contentIds:[ID!]!){pageContent:content(ids:$contentIds,type:\"page\"){nodes{id,visibleDescendantsCount}},whiteboardContent:content(ids:$contentIds,type:\"whiteboard\"){nodes{id,visibleDescendantsCount}},databaseContent:content(ids:$contentIds,type:\"database\"){nodes{id,visibleDescendantsCount}},embedContent:content(ids:$contentIds,type:\"embed\"){nodes{id,visibleDescendantsCount}},folderContent:content(ids:$contentIds,type:\"folder\"){nodes{id,visibleDescendantsCount}}}"
  }
};
})();

(node as any).hash = "441ec5092d7845001c1a3d59a8aa9473";

export default node;
